import { NamedResponse } from '../../../../../shared/models/response-models/named-response.model';
import { WarehouseLocationProfileModel } from '../../location-profiles/models/location-profile.models';

export class WarehouseLocationModel {
  id: number = 0;
  warehouseId: number = 0;
  zoneId: number = 0;
  profileId: number = 0;
  formatId: number = 0;
  formatType: number = 0;
  name: string = '';
  useWarehouseInName: boolean = false;
  useZoneInName: boolean = false;
  aisleStaticText: string = '';
  fromAisle: number = 0;
  toAisle: number = 0;
  fromRack: number = 1;
  toRack: number = 0;
  fromShelf: number = 1;
  toShelf: number = 0;
  fromBin: number = 1;
  toBin: number = 0;
  companyId: number = 0;
  itemsCount: number = 0;
  aisleName: string = '';
  rackName: string = '';
  shelfName: string = '';
  binName: string = '';
  warehouse: NamedResponse = new NamedResponse();
  zone: NamedResponse = new NamedResponse();
  isSystemDefault: boolean = true;
  isScanPull: boolean = true;
}
export class LookUpsModel {
  name: string = '';
  items: LookupItems[] = [];
}
export class LookupItems {
  id: number = 0;
  name: string = '';
}

export class WarehouseLocationType {
  id: number = 0;
  name: string = '';
  description: string = '';
  companyId: number = 0;
}
export class WarehouseLocationResponse {
  totalCount: number = 0;
  pageNumber: number = 0;
  pageSize: number = 0;
  items: Item[] = [];
}
export class ScanLocation {
  name: string = '';
  companyId: number = 0;
  warehouseId: number | null = null;
}

export class WarehouseLocationLiteResponse {
  id = 0;
  name = '';
  zone: NamedResponse | null = null;
  warehouse: NamedResponse | null = null;
  warehouseLocationProfile: WarehouseLocationProfileModel | null = null;
}

export class Item {
  warehouseId: number = 0;
  zoneId: number = 0;
  profileId: number = 0;
  formatType?: number = 0;
  profile: NamedResponse = new NamedResponse();
  name: string = '';
  aisleName: string = '';
  rackName: string = '';
  shelfName: string = '';
  binName: string = '';
  warehouse: NamedResponse = new NamedResponse();
  zone: NamedResponse = new NamedResponse();
  id: number = 0;
  isSystemDefault: boolean = false;
}
